__turbopack_context__.v({
  "className": "source_sans_3_35b2530a-module__RXQ5Ra__className",
  "variable": "source_sans_3_35b2530a-module__RXQ5Ra__variable",
});
